import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoTimeline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideoTimeline"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V16H2V4ZM7.5 8L4 10.625V14H14.8636L7.5 8ZM17.5 10C18.3284 10 19 9.32843 19 8.5C19 7.67157 18.3284 7 17.5 7C16.6716 7 16 7.67157 16 8.5C16 9.32843 16.6716 10 17.5 10Z" fill="currentColor"/><Path d="M8.73244 18H22V20H8.73244C8.38663 20.5978 7.74028 21 7 21C6.25972 21 5.61337 20.5978 5.26756 20H2V18H5.26756C5.61337 17.4022 6.25972 17 7 17C7.74028 17 8.38663 17.4022 8.73244 18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoTimeline;
